import { Classification } from '@shared/constants'

import { deleteRequest, getRequest, postRequest, putRequest } from './request'
import { UpdateTemplateData } from '@shared/types'

import { DOMAIN } from './constant'

export const createTemplateApi = (data: {
  title: string,
  category: number,
  description: string,
  keyword: string[],
  classify: Classification
  extraInfo?: Record<string, any>,
  templateType: number
}) => {
  return postRequest(`${DOMAIN}/api/resource/templates`, data)
}

export const queryTemplatesApi = (filter: {
  keyword?: string,
  classify?: number,
  page?: number,
  pageSize?: number,
  templateType?: number,
  ecommerceFestival?: number,
  holidayTheme?: number,
  industryCategory?: number,
  scenarioUsage?: number,
}) => {
  return postRequest(`${DOMAIN}/api/resource/templates/list`, filter)
}

//  hot 模版
export const queryHotTemplatesApi = (filter: {
  classify?: Classification,
  templateType?: number,
  page?: number,
  pageSize?: number
}) => {
  return postRequest(`${DOMAIN}/api/resource/templates/hot`, filter)
}

//  onboard 模版
export const queryOnboardTemplatesApi = (filter: {
  templateType?: number,
  page?: number,
  pageSize?: number
}) => {
  return getRequest(`${DOMAIN}/api/resource/templates/onboard`, filter)
}



export const updateTemplateApi = (id: string, data: UpdateTemplateData) => { 
  return putRequest(`${DOMAIN}/api/resource/templates/${id}`, data)
}

export const deleteTemplatesApi = (id: string) => {
  return deleteRequest(`${DOMAIN}/api/resource/templates/${id}`)
}

export const queryTemplateByIdApi = (id: string) => {
  return getRequest(`${DOMAIN}/api/resource/templates/${id}`)
}
// /api/resource/copy/templates
export const copyTemplateApi = (data: {
  id: string
}) => {
  return postRequest(`${DOMAIN}/api/resource/copy/templates`, data)
}

export const likeTemplateApi = (tplId: string) => {
  return putRequest(`${DOMAIN}/api/like/templates/${tplId}`, {})
}

export const removeLikeTemplateApi = (tplId: string) => {
  return deleteRequest(`${DOMAIN}/api/like/templates/${tplId}`)
}

export const getLikeTemplateApi = (tplId: string) => {
  return getRequest(`${DOMAIN}/api/like/templates/${tplId}`)
}

export const getLikeTemplateListApi = (query?: {
  withTemplate?: boolean
}) => {
  return getRequest(`${DOMAIN}/api/like/templates`, query)
}

export const getPriorityTemplateListApi = () => {
  return getRequest(`${DOMAIN}/api/resource/templates/priority`)
}